import React, { useState, useEffect } from 'react'; 
import { useAuth } from '../utils/AuthContext/AuthContext';
import { useFormContext } from "../utils/FormContext";
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import createVoidHandler from '../utils/voidContract';
import ContractUpcomingDates from '../components/ContractUpcomingDates';
import Checklist from '../components/Checklist';
import { useMediaQuery } from 'react-responsive';
import config from '../utils/config'
import { resendSignatureLink } from '../utils/resendPacket';
import TerminateButton from '../components/TerminateButton';

// ASSETS
import CompletedSVG from "../assets/Completed";
import SignatureSVG from "../assets/Signature";
import HomeLoadSVG from '../assets/HomeLoad';
import AvatarSVG from '../assets/Avatar';
import PeopleSVG from '../assets/People';
import InfoModal from '../components/InfoModal';
import CalendarSVG from '../assets/Calendar';
import MoneySVG from '../assets/Money';
import TransactionSVG from '../assets/Transaction';
import SchoolSVG from '../assets/School';
import BedroomSVG from '../assets/Bedroom';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';


// Initialize checklist items
const initialChecklistItems = [
  { id: 1, text: 'Lender Letter', isChecked: false },
  { id: 2, text: 'Ask Listing Agent About Earnes Money', isChecked: false },
  { id: 3, text: 'Ask Listing Agent About Water Rights', isChecked: false },
  { id: 4, text: 'Ask Listing Agent About Inclusions', isChecked: false },
  { id: 5, text: 'Filled out Post-Closing Occupancy Agreement', isChecked: false },
  { id: 6, text: 'Proof of Funds for Down Payement & Closing Costs', isChecked: false },
  { id: 7, text: 'Scheduled Inspection', isChecked: false },
  // Add more items as needed
];

function ContractFocus({onTerminated}) {
    const [packetDetails, setPacketDetails] = useState(null);
    const [etchPacketEid, setEtchPacketEid] = useState(null);
    const [propertyDetails, setPropertyDetails] = useState(null);
    const [contractDetails, setContractDetails] = useState(null);
    const [fullForm, setFullForm] = useState(null);
    const [dates, setDates] = useState({});
    
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [handleModalConfirm, setHandleModalConfirm] = useState(null);
    const [handleModalCancel, setHandleModalCancel] = useState(null);
    const [isVoided, setIsVoided] = useState(false);
    const [voidResponse, setVoidResponse] = useState(null);
    const { formData } = useFormContext(); 
    const { formId } = useParams();
    const { token } = useAuth();
    const navigate = useNavigate(); 
    const [isLoading, setIsLoading] = useState(true);
    const [statusMessage, setStatusMessage] = useState('');
    const starEmoji = "⭐"; 
    const [checklistItems, setChecklistItems] = useState(
      () => JSON.parse(localStorage.getItem(`checklistItems-${formId}`)) || initialChecklistItems
    );
    const [handleVoidClick, setHandleVoidClick] = useState(() => () => {});
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    // console.log("token", token);
    useEffect(() => {
      if (packetDetails?.documentGroup?.eid) {
        setHandleVoidClick(() => createVoidHandler(packetDetails?.documentGroup?.eid, etchPacketEid, fullForm?.formId, dispatch, setVoidResponse, setIsVoided, setShowModal, token));
      }
    }, [packetDetails?.documentGroup?.eid]);

    const formatPrice = (price) => {
      return price 
        ? Math.round(price).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).split('.')[0]
        : "Price not available";
    }
    
    
    // let listPrice = propertyDetails?.data?.mlsHistory?.[0]?.price;
    let listPrice = propertyDetails?.propertyDetails?.price;
    // let taxPrice = propertyDetails?.data?.taxInfo?.taxAmount;
    let taxPrice = propertyDetails?.propertyDetails?.taxHistory?.[0]?.taxPaid;
    let formattedPrice = formatPrice(listPrice);
    let formattedTaxPrice = formatPrice(taxPrice);
    // let saleAmount1 = propertyDetails?.data?.saleHistory?.[0]?.saleAmount;
    let saleAmount1 = propertyDetails?.propertyDetails?.saleHistory?.[0]?.saleAmount;
    let formattedSaleAmount1 = formatPrice(saleAmount1);
    let saleAmount2 = propertyDetails?.propertyDetails?.saleHistory?.[1]?.saleAmount;
    let formattedSaleAmount2 = formatPrice(saleAmount2);
    let homeStatus = propertyDetails?.propertyDetails?.keystoneHomeStatus
    ? propertyDetails.propertyDetails.keystoneHomeStatus
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim()
    : 'Status not available';

    const formatDate = (date) => {
      return date
        ? new Date(date).toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        : "Date not available";
    }

    let formUpdatedDate = fullForm?.updatedAt;
    let newFormUpdatedDate = formatDate(formUpdatedDate);
    let propertyUpdatedDate = propertyDetails?.propertyDetails?.priceHistory?.[0]?.date
    let newPropertyUpdatedDate = formatDate(propertyUpdatedDate);
    let saleDate1 = propertyDetails?.data?.saleHistory?.[0]?.saleDate;
    let newSaleDate1 = formatDate(saleDate1);
    let saleDate2 = propertyDetails?.data?.saleHistory?.[1]?.saleDate;
    let newSaleDate2 = formatDate(saleDate2);
    let ownerName = propertyDetails?.propertyDetails?.realieData?.property?.ownerName;
    let seller1Name = '';
    let seller2Name = '';

    if (ownerName) {
        const names = ownerName.split(';').map(name => name.trim());
        seller1Name = names[0] || '';
        seller2Name = names[1] || '';
    }

    function formatPhoneNumber(phoneNumberString) {
      const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null
    }

    const navigateToTerminate = () => {
      window.open('https://drive.google.com/file/d/1LpvYAJR2avuSOgrjlLwqtfvg-yrtbRxA/view?pli=1');
    };

    const navigateToPostClosing = () => {
      window.open('https://drive.google.com/file/d/1EbWUq_S6f85_-OZ6ESPaI-L_YXE71T40/view');
    };

    // RESEND SIGNATURE LINK FUNCTIONALITY
    const handleResendClick = async () => {
      try {
        setIsLoading(true);
        await resendSignatureLink(etchPacketEid, formId, token);
        // Optionally, you can refetch the packet details or update the state
        setIsLoading(false);
      } catch (error) {
        setError(error.toString());
        setIsLoading(false);
      }
    };

    useEffect(() => {
      if (handleModalConfirm !== null || handleModalCancel !== null) {
        setShowModal(true);
      }
    }, [handleModalConfirm, handleModalCancel]);

    useEffect(() => {
      if (fullForm) {
        setDates(fullForm.data.dateFields);
      }

    }, [fullForm]);

    const handleCloseModal = () => {
      setShowModal(false); 
    }; 

    const handleDelete = async () => {
      try {
        // Check if packetDetails exists and is not completed
        if (packetDetails && packetDetails?.documentGroup?.status !== 'completed') {
          // Void the packet
          await handleVoidClick();
        }

        // const response = await fetch(`http://localhost:5000/api/formdata/${formId}`, {
          const response = await fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
          // console.log("Trying for FormId:", formId);
        }
        // handle successful deletion here (e.g., redirect to another page)
        navigate(`/`);
      } catch (error) {
        console.error('Error:', error);
        // console.log("Trying for FormId:", formId);
      }
    };

  const navigateToFormData = () => {
    navigate(`/formdata/${fullForm?.formId || formId}`, { state: {step: 2 } });
};

const navigateToAmendment = () => {
  // Assuming `packetDetails` or another relevant prop has the necessary data
  navigate(`/amendextend`, { 
    state: {
      step: 2,
      formId: fullForm?.formId || formId, // Example prop, adjust based on actual data structure
      // Add other necessary data here
    } 
  });
};

const navigateToAmendmentForm = () => {
  const lastAmendment = fullForm?.amendments?.[fullForm.amendments.length - 1];
  navigate(`/amendment/${lastAmendment?.amendmentId}`);
};

useEffect(() => {
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setEtchPacketEid(data.etchPacketEid);
      setChecklistItems(data.checklist.length > 0 ? data.checklist : initialChecklistItems);
      setPropertyDetails(data.propertyData);
      setContractDetails(data.data);
      setFullForm(data);

      if (data.data?.status !== 'terminated' && data?.packetDetails?.status !== 'draft') {
        const packetResponse = await fetch(`${config.apiBaseUrl}/packet/${data.etchPacketEid}`);
        if (!packetResponse.ok) {
          throw new Error(`HTTP error! status: ${packetResponse.status}`);
        }
        const packetData = await packetResponse.json();
        setPacketDetails(packetData);

        const updateResponse = await fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            etchPacketEid: etchPacketEid,
            packetDetails: packetData.data.etchPacket,
          }),
        });

        if (!updateResponse.ok) {
          throw new Error(`HTTP error! status: ${updateResponse.status}`);
        }

        const updateData = await updateResponse.json();
        setPacketDetails(updateData.packetDetails);
      }

      setIsLoading(false);
    } catch (e) {
      setError(e.toString());
      setIsLoading(false);
    }
  };

  fetchData();
}, [formId, token]);

  // Update local storage whenever checklistItems changes
    useEffect(() => {
      // Update local storage
      localStorage.setItem(`checklistItems-${formId}`, JSON.stringify(checklistItems));

  }, [checklistItems]);

    let status, statusClasses, remainingSigners;

    if (fullForm?.packetDetails) {
      status = fullForm.packetDetails.status;
      remainingSigners = fullForm.packetDetails.numberRemainingSigners;
      if (status === 'completed') {  
        statusClasses = "bg-green-100 text-green-600 rounded-xl text-center p-1";
      } else if (fullForm?.packetDetails?.documentGroup?.status === 'terminated') {
        statusClasses = "bg-red-100 text-red-700 rounded-xl text-center p-1";
      } else if (status === 'draft' || isVoided) {
        statusClasses = "bg-slate-100 text-slate-700 rounded-xl text-center p-1";
      } else {
        statusClasses = "bg-blue-100 text-blue-700 rounded-xl text-center p-1";
      }
    } else {
      // Default values when fullForm or packetDetails is not available
      status = 'draft';
      statusClasses = "bg-slate-100 text-slate-700 rounded-xl text-center p-1";
      remainingSigners = 0;
    }

  if (packetDetails && packetDetails.documentGroup && packetDetails.documentGroup.signers) {
    const lastCompletedRoutingOrder = packetDetails.documentGroup.signers.reduce((maxOrder, signer) => {
      return (signer && signer.status === 'completed') ? Math.max(maxOrder, signer.routingOrder) : maxOrder;
    }, 0);

    packetDetails.documentGroup.signers = packetDetails.documentGroup.signers.map((signer, index) => {
      let statusText;
      if (signer && signer.status === 'completed') {
        statusText = 'Signed';
      } else if (signer && signer.status === 'viewed') {
        statusText = 'Viewed';
      } 
      else if (signer && signer.routingOrder === lastCompletedRoutingOrder + 1) {
        statusText = 'Awaiting Signature';
      }
      else {
        statusText = 'Awaiting Email After Signer Above Signs';
      }
      return { ...signer, statusText }; // return the signer object with the statusText
    })
  }

  return (
    <>
    {isLoading ? (
      <div className='flex justify-center items-center w-[350px] md:w-[650px] h-full'>
        <div className='flex flex-col jusitfy-center items-center'>
          {isMobile ? <LoadingSpinner width={75} height={75}/> : <LoadingSpinner width={200} height={200}/>}
          <h1 className='text-lg md:text-2xl items-center'>Gathering Contract Info</h1>
        </div>
      </div>
    ) : (
    <div className="md:items-center flex flex-col">
      <div className='w-full mb-5 md:mb-10 px-2'>
        <h1 className="text-black text-lg md:text-4xl font-light">{contractDetails && contractDetails.address ? Object.values(contractDetails.address).join(', ') : ''}</h1>
          <div className='inline-flex items-center'>
          {isMobile ? <CalendarSVG width={18} height={18}/> : <CalendarSVG width={25} height={25}/>}
            <div className='flex flex-col mt-3 md:mt-5 ml-1 md:ml-2'>
              <p className='text-sm text-slate-600'>Last Updated</p>
              <p className='text-slate-600 text-[14px] md:text-lg'>{newFormUpdatedDate}</p>
            </div>
          </div>
      </div>
        <div className="flex flex-col w-full px-2 gap-4">
          {/* Top row with Key Deadlines and Contract Details */}
          <div className="flex flex-col md:flex-row gap-4">
            {/* Key Deadlines Section - 33% width */}
            <div className="w-full md:w-1/3 p-5 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] overflow-y-auto">
              <div className="flex flex-col">
                <div className='flex-col'> 
                  <ContractUpcomingDates dates={dates} />
                </div>            
              </div>
            </div>

            {/* Contract Details Section - 67% width */}
            <div className="w-full md:w-2/3 p-5 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] overflow-y-auto">
              <div className='inline-flex w-full justify-between mb-5'>
                <h1 className='text-[18px] md:text-2xl font-semibold'>Contract Details</h1>
                <div className={`p-1 px-3 inline-flex items-center text-[12px] md:text-sm font-[Inter] justify-center ${statusClasses}`}>{status === "completed" ? "Completed" : fullForm?.packetDetails?.documentGroup?.status === 'terminated' ? "Terminated" : status === 'draft' || isVoided ? 'Voided' : "In Progress"}</div>
              </div>
              {(packetDetails || propertyDetails) && (
                <div>
                  <div className="flex w-full justify-between items-start mb-10">
                    <div className="flex">
                      <div className="flex flex-col mr-2">
                        <span className='text-slate-600 text-sm'>Listing Price</span>
                        <span className='text-[18px] md:text-3xl'>{formattedPrice}</span>
                      </div>
                      <div className="border-l mx-3"></div>
                      <div className="flex flex-col ml-2">
                        <span className='text-slate-600 text-sm'>Your Offer</span>
                        <span className='text-[18px] md:text-3xl'>${contractDetails?.prices?.[0].purchasePrice}</span>
                      </div>
                    </div>
                  </div>
                  {
                    packetDetails?.documentGroup && packetDetails?.documentGroup?.signers && packetDetails?.documentGroup?.signers?.map((signer, index) => {
                      return (
                        <div key={index} className="flex-col items-center justify-start gap-2">
                          <div className='inline-flex items-center'>
                            {signer.status === 'completed' && <CompletedSVG width={20} height={20}/>}
                            {signer.status === 'sent' && <SignatureSVG width={20} height={20}/>}
                            {signer.status === 'viewed' && '👀'}
                            <h1 className="text-[14px] md:text-lg pl-2 pr-2 font-bold text-shi-deep-purple">{signer.name}</h1>
                            <span className='pr-2'>&bull;</span>
                            <span className='text-[14px] md:text-lg'>
                              {signer.statusText} 
                            </span>
                          </div>
                          <div className="text-[14px] md:text-lg inline-flex justify-start w-full md:w-[750px] ml-11">
                            <span className="mb-3 pr-4">#{signer.routingOrder} Signer</span>
                            <span>{signer.email}</span>
                          </div>
                        </div>
                      );
                    })
                  }
                  <hr className='my-3 md:my-5 bg-slate-700'></hr>
                  <div className='inline-flex justify-between w-full mb-5'>
                    <h1 className='text-[18px] md:text-2xl font-semibold mt-2 md:mt-0'>Home Details</h1>
                    <div className='flex-col items-left'>
                      <p className='text-sm text-slate-600'>{newPropertyUpdatedDate}</p>
                      <div className={`rounded-xl text-[12px] md:text-sm items-center inline-flex justify-center w-auto p-1 px-3 ${homeStatus === 'For Sale' ? 'bg-green-200 text-green-600' : homeStatus !== 'For Sale' ? 'bg-slate-200 text-black' : ''}`}>
                        {homeStatus}
                      </div>
                    </div>
                  </div>

                  {propertyDetails?.propertyDetails && (
                    <div className="grid grid-cols-2 gap-4 mb-5">
                      <div>
                      {/* {propertyDetails?.data?.mlsHistory?.length > 0 && ( */}
                        <div className='inline-flex mb-5'>
                          <AvatarSVG width={24} height={24}/>
                          <div className='flex flex-col gap-2'>
                            <p className='text-sm px-2  text-slate-600'>Listing Agent</p>
                            <div className='inline-flex items-center'>
                              <span className='text-[12px] md:text-[16px] pl-2 pr-1.5 font-semibold'>{propertyDetails?.propertyDetails?.attributionInfo?.agentName}</span>
                              &bull; 
                              <span className='text-[12px] md:text-[16px] pl-1.5 text-sm text-slate-600'>{formatPhoneNumber(propertyDetails?.propertyDetails?.attributionInfo?.agentPhoneNumber)}</span>
                            </div>
                            <span className='text-[12px] md:text-[16px] px-2 font-semibold'>{propertyDetails?.propertyDetails?.attributionInfo?.brokerName}</span>
                          </div>
                        </div>
                      {/* )} */}

                      <div className='inline-flex mb-5'>
                          <BedroomSVG width={24} height={24}/>
                          <div className='flex flex-col gap-2 '>
                            <p className='px-2 text-slate-600 text-sm'>Property Info</p>
                            <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Bed / Bath: </span><strong>{propertyDetails?.propertyDetails?.resoFacts?.bedrooms} bd / {propertyDetails?.propertyDetails?.resoFacts?.bathrooms} ba</strong></p>
                            {/* <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Basement: </span><strong>{propertyDetails?.propertyDetails?.resoFacts?.}</strong></p> */}
                            <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Finished SQF: </span><strong>{propertyDetails?.propertyDetails?.livingAreaValue} sqf</strong></p>
                            {/* <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Basement Finished SQF: </span><strong>{propertyDetails?.data?.propertyInfo?.basementSquareFeetFinished} sqf</strong></p> */}
                            <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Garage: </span><strong>{propertyDetails?.propertyDetails?.hasGarage === true ? 'Yes' : 'No'}</strong></p>
                            {/* <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Heating: </span><strong>{propertyDetails?.data?.propertyInfo?.heatingType} {propertyDetails?.data?.propertyInfo?.heatingFuelType}</strong></p> */}
                            <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Year Built: </span><strong>{propertyDetails?.propertyDetails?.yearBuilt}</strong></p>
                            <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Lot: </span><strong>{propertyDetails?.propertyDetails?.lotSize} sqf</strong></p>
                          </div>
                        </div>

                        <div className='inline-flex mb-5'>
                          <MoneySVG width={24} height={24}/>
                          <div className='flex flex-col gap-2 '>
                            <div className='inline-flex items-center'>
                              <p className='text-sm px-2 text-slate-600'>Tax Info</p>
                              &bull;
                              <p className='text-[12px] md:text-[16px] px-2 text-slate-600'>{taxPrice}</p>
                            </div>
                            <p className="text-[12px] md:text-[16px] px-2 font-semibold">{formattedTaxPrice}</p>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div className='inline-flex mb-5'>
                          {isMobile ? <PeopleSVG width={20} height={20}/> : <PeopleSVG width={24} height={24}/>}
                          <div className='flex flex-col gap-2'>
                            <p className='text-sm px-2  text-slate-600'>Sellers</p>
                            <p className="text-[12px] md:text-[16px] px-2 font-semibold">{seller1Name}</p>
                            <p className='text-[12px] md:text-[16px] px-2 font-semibold'>{seller2Name && seller2Name}</p>
                          </div>
                        </div>

                        {(propertyDetails?.propertyDetails?.priceHistory) && (
                        <div className='inline-flex mb-5'>
                          {isMobile ? <TransactionSVG width={20} height={20}/> : <TransactionSVG width={24} height={24}/>}
                          <div className='flex flex-col gap-2 '>
                          <p className='text-sm px-2 text-slate-600'>Price History</p>
                          <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[14px]">{formatDate(propertyDetails?.propertyDetails?.priceHistory?.[0]?.date) + ' '} {propertyDetails?.propertyDetails?.priceHistory?.[0]?.event + ' '} </span><strong className="text-black">{formatPrice(propertyDetails?.propertyDetails?.priceHistory?.[0]?.price)}</strong></p>
                          <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[14px]">{formatDate(propertyDetails?.propertyDetails?.priceHistory?.[1]?.date) + ' '} {propertyDetails?.propertyDetails?.priceHistory?.[1]?.event + ' '} </span><strong className="text-black">{formatPrice(propertyDetails?.propertyDetails?.priceHistory?.[1]?.price)}</strong></p>
                          <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[14px]">{formatDate(propertyDetails?.propertyDetails?.priceHistory?.[2]?.date) + ' '} {propertyDetails?.propertyDetails?.priceHistory?.[2]?.event + ' '} </span><strong className="text-black">{formatPrice(propertyDetails?.propertyDetails?.priceHistory?.[2]?.price)}</strong></p>
                          {/* {propertyDetails?.data?.saleHistory?.length > 1 && (
                            <div className='flex flex-col gap-2'>
                              <hr className='my-2 bg-slate-700'></hr>
                              <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Buyer: </span><strong>{propertyDetails?.data?.saleHistory?.[1]?.buyerNames}</strong></p>
                              <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Price: </span><strong>{formattedSaleAmount2}</strong></p>
                              <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Date: </span><strong>{newSaleDate2}</strong></p>
                              <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Deed: </span><strong>{propertyDetails?.data?.saleHistory?.[1]?.documentType}</strong></p>
                            </div>
                          )} */}
                          </div>
                        </div>
                      )}

                      <div>
                      {propertyDetails?.propertyDetails?.schools.length > 0 && (
                        <div className='inline-flex mb-5'>
                        {isMobile ? <SchoolSVG width={20} height={20}/> : <SchoolSVG width={24} height={24}/>}
                          
                          <div className='flex flex-col gap-2 '>
                            <div className='inline-flex items-center'>
                              <p className='text-sm px-2 text-slate-600'>Education</p>
                            </div>
                            <div className='flex flex-col'>
                              <div className='inline-flex items-center'>
                                <p className='text-[12px] md:text-[16px] px-2 text-slate-600'>{propertyDetails?.propertyDetails?.schools?.[0]?.grades}</p>
                                &bull;
                                <p className='text-[12px] md:text-[16px] px-2 text-slate-600'>Parent Rating: {propertyDetails?.propertyDetails?.schools?.[0]?.rating} {starEmoji}</p>
                              </div>
                              <p className='text-[12px] md:text-[16px] px-2 font-semibold text-black'>{propertyDetails?.propertyDetails?.schools?.[0]?.name}</p>
                            </div>
                            <hr className='my-2 ml-1.5 bg-slate-700' />
                            <div className='flex flex-col'>
                              <div className='inline-flex items-center'>
                              <p className='text-[12px] md:text-[16px] px-2 text-slate-600'>{propertyDetails?.propertyDetails?.schools?.[1]?.grades}</p>
                                &bull;
                                <p className='text-[12px] md:text-[16px] px-2 text-slate-600'>Parent Rating: {propertyDetails?.propertyDetails?.schools?.[1]?.rating} {starEmoji}</p>
                              </div>
                              <p className='text-[12px] md:text-[16px] px-2 font-semibold text-black'>{propertyDetails?.propertyDetails?.schools?.[1]?.name}</p>
                            </div>
                            <hr className='my-2 ml-1.5 bg-slate-700' />
                            <div className='flex flex-col'>
                              <div className='inline-flex items-center'>
                              <p className='text-[12px] md:text-[16px] px-2 text-slate-600'>{propertyDetails?.propertyDetails?.schools?.[2]?.grades}</p>
                                &bull;
                                <p className='text-[12px] md:text-[16px] px-2 text-slate-600'>Parent Rating: {propertyDetails?.propertyDetails?.schools?.[2]?.rating} {starEmoji}</p>
                              </div>
                              <p className='text-[12px] md:text-[16px] px-2 font-semibold text-black'>{propertyDetails?.propertyDetails?.schools?.[2]?.name}</p>
                            </div>
                          </div>
                        </div>
                      )}
                      </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Manage Contract Section - Full width below */}
          {!isLoading && (
            <div className="w-full p-5 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px]">
              <h1 className='font-semibold text-[18px] md:text-2xl mb-2 md:mb-5'>Manage Contract</h1>
              <div className='flex flex-col gap-[3px] md:gap-2'>

                   <div className="items-center">
                     <button 
                       className={`text-[15px] md:text-[17px] font-['Inter'] p-1.5 ${!packetDetails?.documentGroup?.files?.[0]?.downloadURL ? 'text-gray-300' : 'text-black'}`}
                       disabled={!packetDetails?.documentGroup?.files?.[0]?.downloadURL}
                     >
                       <a href={packetDetails?.documentGroup?.files?.[0]?.downloadURL}>Download Contract</a>
                       {/* <a href={`https://app.useanvil.com/api/document-group/${packetDetails?.documentGroup?.eid}/Colorado-Residential-Purchase-Agreement-Realtor-Version.pdf`}>Download Contract</a> */}
                     </button>
                   </div>

              <div className="items-center">
                <button 
                  className={`text-[15px] md:text-[17px] font-['Inter'] p-1.5 ${(packetDetails && packetDetails?.documentGroup?.status === 'completed' && !isVoided) || !packetDetails ? 'text-gray-300' : 'text-black'}`}
                  onClick={() => {
                    setModalContent('Are you sure you want to void this contract?');
                    setHandleModalConfirm(() => handleVoidClick);
                    setHandleModalCancel(() => setShowModal(false));
                    }
                  }
                  disabled={(packetDetails && packetDetails?.status === 'completed' && !isVoided) || !packetDetails}
                >
                  Void Contract
                </button>
              </div>

              <div className="items-center">
                <button 
                  // className={`text-lg font-Inter p-1.5 ${(packetDetails?.eid) ? 'text-gray-300' : 'text-shi-green'}`}
                  className={`text-[15px] md:text-[17px] font-Inter text-black p-1.5 ${(packetDetails?.status !== 'completed') ? 'text-black' : 'text-gray-300'}`}
                  onClick={navigateToFormData}  
                  disabled={(packetDetails?.status === 'completed')} 
                >
                  Edit Contract
                </button>
              </div>
              
              <div className="items-center">
                <button 
                  className={`text-[15px] md:text-[17px] font-['Inter'] p-1.5 ${(packetDetails?.eid && packetDetails?.status !== 'completed' || isVoided) ? 'text-black' : 'text-gray-300'}`}
                  onClick={handleResendClick}  
                  disabled={(packetDetails?.status === 'completed' || !(packetDetails))} 
                >
                  Resend to Next Signer
                </button>
              </div>

              <div className="items-center">
                <button 
                  className={`text-[15px] md:text-[17px] font-['Inter'] p-1.5 ${(!packetDetails?.eid || packetDetails?.status !== 'completed' || isVoided) ? 'text-gray-300' : 'text-black'}`}
                  onClick={navigateToAmendment}  
                  disabled={packetDetails?.status !== 'completed'} 
                >
                  Add Amend Extend
                </button>
              </div>

              <div className="text-left">
                <button 
                  className={`text-left text-[15px] md:text-[17px] font-['Inter'] p-1.5 ${(packetDetails?.status !== 'completed' || isVoided) ? 'text-gray-300' : 'text-black'}`}
                  onClick={navigateToPostClosing}  
                  disabled={(packetDetails?.status !== 'completed')} 
                >
                  Add Post-Closing Occupancy Agreement
                </button>
              </div>

              <div className="items-left">
                <button 
                  className={`text-[15px] md:text-[17px] font-['Inter'] p-1.5  text-red-700`}
                  onClick={navigateToTerminate}
                  
                >
                  Add Termination Form
                </button>
              </div> 

              <div className="items-center">
                <button 
                  className=" text-red-700 text-[15px] md:text-[17px] font-['Inter'] p-1.5"
                  onClick={() => {
                    setModalContent(`This action will remove the contract from your dashboard and void any incomplete e-signatures.  Note: This is NOT a legal termination of a binding contract. If you need to terminate an active contract, please consult an attorney or submit a formal termination form. Are you sure you want to delete this contract?`);
                    setHandleModalConfirm(() => handleDelete);
                    setHandleModalCancel(() => setShowModal(false));
                  }}
                >
                  Remove From Shishito
                </button>
              </div> 
          </div>
          <hr className='my-5 bg-slate-700' />
          <h1 className='font-semibold text-[18px] md:text-2xl mb-2 md:mb-5'>Other Documents</h1>
          {fullForm?.amendments?.length > 0 && (
            <div className="items-center">
                  <button 
                    className={`text-[15px] md:text-[17px] font-['Inter'] p-1.5 ${'text-black'}`}
                    onClick={navigateToAmendmentForm}
                  >
                    View Amend Extend Form
                  </button>
                </div>
          )}
      </div>
      )}
    </div>
    

        <InfoModal 
          isOpen={showModal} 
          onClose={handleCloseModal} 
          content={modalContent} 
          onConfirm={handleModalConfirm} 
          onCancel={handleModalCancel}
        >
          <div>
              <p>{modalContent}</p>
              <div className='w-[300px] md:w-full mt-3 inline-flex gap-5 md:gap-20 justify-center items-center'>
                  <button 
                      className='border border-red-600 rounded-md p-1.5 w-[60px] md:w-[80px] hover:bg-slate-200' 
                      onClick={handleModalConfirm}
                      >Yes</button>
                  <button 
                      className='border border-black rounded-md p-1.5 w-[60px] md:w-[80px] hover:bg-slate-200' 
                      onClick={() => setShowModal(false)}
                  >No</button>
              </div>
          </div>
        </InfoModal>
      </div>
    )}
    </>
  )
}

export default ContractFocus;